<template>
  <div>
    <!-- h5 -->
    <div class="banner-mobile">
      <img class="img" src='../../../../assets/images/mixOsBannerMobile.png' />
      <div class="con">
        <div class="title">混合云</div>
        <div class="des">核心资源不出本地，为中大型企业打造专属定制系统，提供多应用场景下合同管理、电子签章、用印管理的一体化解决方案。</div>
        <div class="btn" @click="showDialog">了解更多</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showForm: Boolean,
    list: Array,
    video: String,
    landingPageName: {
      type: String,
      default: '',
    },
  },
  components: {},
  methods: {
    closeform(e) {
      console.log(e)
    },
    showDialog() {
      this.$emit('showDialog')
    },
    setShowSuccessDialog(v) {
      this.$emit('setShowSuccessDialog', v)
    },
  },
}
</script>

<style lang="less" scoped>
  .banner {
    display: none;
  }
  .banner-mobile {
    width: 100%;
    height: 9.6rem;
    // background: url('../../../../assets/images/mixOsBannerMobile.png') no-repeat;
    // background-size: contain;
    // padding: 98px 28px 80px;
    position: relative;
    .img {
      width: 100%;
      height: 9.6rem;
    }
    .con {
      position: absolute;
      top: 2.1333rem;
      padding: 0 0.7467rem;
      min-width: auto;
      .title {
        font-size: .7467rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 1.0667rem;
        letter-spacing: .0533rem;
        text-align: center;
        margin-bottom: .2667rem;
      }
      .des {
        font-size: .3733rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: .5333rem;
        letter-spacing: 1px;
        text-align: center;
        margin-bottom: 1.0667rem;
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.6667rem;
        height: .8rem;
        background: #E61717;
        text-align: center;
        font-size: .32rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: .4533rem;
        margin: 0 auto;
      }
    }
  }
</style>
